/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { ThemeProvider, jsx } from '@emotion/react';

import * as React from 'react';

import enterpriseIndexConfig from 'bundles/enterprise-learner-search/components/search/enterpriseIndexConfig';
import SearchProvider from 'bundles/search-common/providers/SearchProvider';
import type { SearchContext } from 'bundles/search-common/providers/searchTypes';
import { searchTheme } from 'bundles/search-common/searchTheme';

export const EnterpriseSearchProviderWrapper = ({
  children,
  searchContext,
  shouldEnableShortFormContent,
  facets,
  facetFilters,
  shouldSyncFiltersWithUrl,
}: {
  children: React.ReactNode;
  searchContext?: SearchContext;
  shouldEnableShortFormContent: boolean;
  facets?: string[];
  facetFilters?: string[][];
  shouldSyncFiltersWithUrl?: boolean;
}) => {
  return (
    <ThemeProvider theme={searchTheme}>
      <SearchProvider
        searchConfigs={enterpriseIndexConfig({
          searchContext,
          shouldEnableShortFormContent,
          facets,
          facetFilters,
          shouldSyncFiltersWithUrl,
        })}
      >
        {children}
      </SearchProvider>
    </ThemeProvider>
  );
};

export default EnterpriseSearchProviderWrapper;
